export default {
  fi: {
    FaultShowScene: {
      backLink: 'Takaisin',
      delete: 'Poista',
      createReminder: 'Luo muistutus',
      description: 'Kuvaus',
      createdAt: 'Luotu',
      userName: 'Ilmoittaja',
      markAsRead: 'Merkitse luetuksi',
      markAsUnread: 'Merkitse lukemattomaksi',
      toastMarkedAsRead: 'Vikailmoitus merkittiin luetuksi.',
      toastMarkedAsUnread: 'Vikailmoitus merkittiin lukemattomaksi.',
      deleteConfirmTitle: 'Poistetaanko vikailmoitus?',
      deleteConfirmDescription: 'Tätä toimintoa ei voi perua.',
      deleteConfirm: 'Poista',
      deleteCancel: 'Peruuta',
    },
  },
};
